<div class="alertbox success">
    <div class="icon">
        <img src="assets/img/icon/success.png" alt="Success">
    </div>
    <h4>{{ "Congrats" | translate }}</h4>
    <div>
        {{ "Pay anywhere with your QR Code" | translate }}
        <img [src]="pixUrl" width="183" height="183" alt="QR" class="pixUrl" />
        <div *ngIf="paymentResult?.extra.pixCode" class="item cursor-copy" ngxClipboard [cbContent]="paymentResult?.extra.pixCode" (cbOnSuccess)="alertService.setNotice('Copied', 'success')">
            <span>{{ 'Pix Code' | translate }}:</span>
            <p class="pixCode">
                <input class="form-control" [value]="paymentResult?.extra.pixCode" readonly />
                <img class="cursor-copy" src="assets/img/icon/copy.svg" alt="Copy" width="16" height="17" ngxClipboard [cbContent]="paymentResult?.extra.pixCode" (cbOnSuccess)="alertService.setNotice('Copied', 'success')" />
            </p>

        </div>
        <div class="item cursor-copy" ngxClipboard [cbContent]="paymentResult?.reference" (cbOnSuccess)="alertService?.setNotice('Copied', 'success')">
            <span>{{ 'Payment Reference Number' | translate }}:</span>
            <p><span>{{ paymentResult?.reference }}</span>
                <img class="cursor-copy ml-2" src="assets/img/icon/copy.svg" alt="Copy" width="16" height="17" ngxClipboard [cbContent]="paymentResult?.reference" (cbOnSuccess)="alertService.setNotice('Copied', 'success')" /></p>
        </div>
    </div>
</div>
<div class="pButton">
    <button class="btn btn-primary" (click)="backToMerchant()">{{ "Back to Merchant" | translate }}</button>
</div>